import { takeLatest, select, call, put } from 'redux-saga/effects';
import safeSaga from '../safeSaga';
import { UPDATE_GCC_PRODUCT_DETAILS_SUCCESS } from '../../actions/actionTypes';
import { productDetailsSelector } from '../../selectors';
import { getSpecialOrderDeliveryTime } from '../../api/eleanorApi';
import { updateSODeliveryTime } from '../../actions/deliveryActions';

function* getDeliveryTime() {
  const { siteId, partnerProductId } = yield select(productDetailsSelector);
  let deliveryTime = {};
  let productionLeadTime = null;

  try {
    if (siteId && partnerProductId) {
      const response = yield call(getSpecialOrderDeliveryTime, siteId, partnerProductId);
      let {
        startDate,
        endDate,
        adjustedStartDate,
        adjustedEndDate,
      } = response;

      if (adjustedStartDate && adjustedEndDate) {
        startDate = adjustedStartDate;
        endDate = adjustedEndDate;
      }

      deliveryTime = {
        startDate: new Date(startDate),
        endDate: new Date(endDate),
      };
      productionLeadTime = response.productionLeadTimeInDays;
    }
  } finally {
    yield put(updateSODeliveryTime(deliveryTime, productionLeadTime));
  }
}

export default function* deliveryTimeSaga() {
  yield takeLatest(UPDATE_GCC_PRODUCT_DETAILS_SUCCESS, safeSaga(getDeliveryTime));
}
